var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledSectionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#00B574",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22.5,
    height: 22.5,
    rx: 11.5,
    stroke: "#00B574"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3621 7.32279C17.6256 7.52361 17.6765 7.90009 17.4757 8.16367L11.0757 16.5637C10.9708 16.7014 10.8115 16.7871 10.6387 16.7987C10.466 16.8103 10.2966 16.7467 10.1742 16.6243L6.57417 13.0243C6.33986 12.79 6.33986 12.4101 6.57417 12.1758C6.80849 11.9415 7.18839 11.9415 7.4227 12.1758L10.5372 15.2903L16.5212 7.43642C16.722 7.17284 17.0985 7.12196 17.3621 7.32279Z",
    fill: "#00B574"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledSectionIcon);
export default __webpack_public_path__ + "static/media/FilledSectionIcon.01e7cd1623c2fbc689f03246c72fc73e.svg";
export { ForwardRef as ReactComponent };